import { DialogActions, DialogContext, DialogSessionContext } from 'components/feedback/Overlay/OverlayContext'
import { Dispatch, SetStateAction, useCallback, useContext } from 'react'

export const useDialog = () => {
  const context = useContext(DialogContext)
  if (context === undefined) {
    throw new Error('useDialog must be used within an OverlayProvider')
  }

  // Id du dialog dans lequel ce composant est rendu (undefined hors dialog → cible le plus récent).
  const sessionId = useContext(DialogSessionContext)

  // Setters bruts (stables) du provider : on les fige pour ne pas recréer les wrappers à chaque
  // changement de session (sinon les effets qui en dépendent boucleraient).
  const rawSetDialogActions = context.setDialogActions
  const rawSetDialogTitle = context.setDialogTitle

  const setDialogActions: Dispatch<SetStateAction<DialogActions | undefined>> = useCallback(
    (actions) => rawSetDialogActions(actions, sessionId),
    [rawSetDialogActions, sessionId]
  )

  const setDialogTitle = useCallback(
    (title: string) => rawSetDialogTitle(title, sessionId),
    [rawSetDialogTitle, sessionId]
  )

  return { ...context, setDialogActions, setDialogTitle }
}
